// extracted by mini-css-extract-plugin
module.exports = {"FoldableFiltersContent":"FoldableFilters_FoldableFiltersContent__11bz-"};